import PropTypes from 'prop-types';
import { PublicRoute, PrivateRoute } from 'modules/common/routes';
import { getUserId } from 'modules/common/utils';

const RouteWithLayout = ({ layout: Layout, component: Component, title, protectedRoute, exact, ...rest }) => {
  const isAuthenticated = !!getUserId();

  document.title = `${title} | TOTO IS`;

  return protectedRoute ? (
    <PrivateRoute
      isAuthenticated={isAuthenticated}
      exact={exact}
      component={(matchProps) => (
        <Layout {...rest}>
          <Component {...matchProps} />
        </Layout>
      )}
      {...rest}
    />
  ) : (
    <PublicRoute
      isAuthenticated={isAuthenticated}
      exact={exact}
      component={(matchProps) => (
        <Layout {...rest}>
          <Component {...matchProps} />
        </Layout>
      )}
      {...rest}
    />
  );
};

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  protectedRoute: PropTypes.bool,
};

export default RouteWithLayout;
